import { buildEditingModeHref, SITE } from '@/app/constants';

const BASE = 'https://image01.cf.vidu.studio/vidu/media-asset';

/** 核心能力两张卡的背景视频走 CDN，按部署站点切换（国内阿里云 / 海外 cf）。 */
const FEATURE_VIDEO_BASE =
  SITE === 'china'
    ? 'https://image01-aliyun.vidu.zone/vidu/media-asset'
    : 'https://image01.cf.vidu.studio/vidu/media-asset';

// 首屏视频与封面。
export const HERO_VIDEO_POSTER = `${BASE}/vidu-video-UvfAcAEm-mti28jud-0486d77c.webp`;
export const HERO_VIDEO_SRC = `${BASE}/vidu-video-UvfAcAEm-mti28jud-d8a26a95.mp4`;
export const HERO_VIDEO_MOBILE_SRC = HERO_VIDEO_SRC;

// 兼容旧卡片常量，当前页面案例区使用 POPULAR_CASES。
export const CARD2_VIDEO_POSTER = `${BASE}/file_v3_0014u_a70275b4-2914-4f07-a370-b248a879733g_c5526eda-5a58-4ce0-a042-883e8dcf8dde-20daac7d.webp`;
export const CARD2_VIDEO_SRC = `${BASE}/file_v3_0014u_a70275b4-2914-4f07-a370-b248a879733g_c5526eda-5a58-4ce0-a042-883e8dcf8dde-975831ae.mp4`;
export const CARD3_VIDEO_POSTER = `${BASE}/case%205-c9e4d24a.webp`;
export const CARD3_VIDEO_SRC = `${BASE}/case%205-9506b9c9.mp4`;
export const CARD4_VIDEO_POSTER = `${BASE}/case%203-10d46a70.webp`;
export const CARD4_VIDEO_SRC = `${BASE}/case%203-778ee053.mp4`;

/**
 * 核心能力两张卡的背景视频，索引与 FEATURE_KEYS 前两项（f1 / f2）对应。
 * 默认停在 poster 封面，hover 起播（始终静音），离开暂停回首帧 —— 逻辑在 ViduS。
 *   avatar（索引 0）/ editing（索引 1）
 */
export const FEATURE_CARD_VIDEOS = [
  {
    src: `${FEATURE_VIDEO_BASE}/vidu-video-o90G5D0T-mtqnmfbx-bd205333.mp4`,
    poster: `${FEATURE_VIDEO_BASE}/vidu-video-o90G5D0T-mtqnmfbx-14e7ad6b.webp`,
  },
  {
    src: `${FEATURE_VIDEO_BASE}/vidu-video-iSpMuSYg-mtqnnv1z-91000412.mp4`,
    poster: `${FEATURE_VIDEO_BASE}/vidu-video-iSpMuSYg-mtqnnv1z-4d396935.webp`,
  },
];

/** 能力卡（复杂动作/持品互动）的演示视频：默认停在 poster，hover 起播；按站点切 CDN。 */
export const S15_CARD1_VIDEO = {
  src: `${FEATURE_VIDEO_BASE}/vidu-video-ry6tTVhl-mtresqoc-f1b352d3.mp4`,
  poster: `${FEATURE_VIDEO_BASE}/vidu-video-ry6tTVhl-mtresqoc-4b8bf84f.webp`,
};

export const S15_CARD2_VIDEO = {
  src: `${FEATURE_VIDEO_BASE}/vidu-video-4JBhA5fL-mts1pwna-fa911203.mp4`,
  poster: `${FEATURE_VIDEO_BASE}/vidu-video-4JBhA5fL-mts1pwna-edc74513.webp`,
};

export const S15_CARD3_VIDEO = {
  src: `${FEATURE_VIDEO_BASE}/20260908-114818-aec2545d.mp4`,
  poster: `${FEATURE_VIDEO_BASE}/20260908-114818-f9c08ee8.webp`,
};

export const S15_CARD4_VIDEO = {
  src: `${FEATURE_VIDEO_BASE}/20260908-134913-4667bfd1.mp4`,
  poster: `${FEATURE_VIDEO_BASE}/20260908-134913-85d26b7d.webp`,
};

/** Editing 能做什么（第二段）专属：卡 1 用独立演示视频，其余卡复用 S15。 */
export const S15B_CARD1_VIDEO = {
  src: `${FEATURE_VIDEO_BASE}/vidu-video-gEKyJoRr-mtsd1jh9-31dccb1d.mp4`,
  poster: `${FEATURE_VIDEO_BASE}/Frame 168655925644-ae020361.webp`,
};

/** Editing 能做什么（第二段）专属：卡 2 用独立演示视频，其余卡复用 S15。 */
export const S15B_CARD2_VIDEO = {
  src: `${FEATURE_VIDEO_BASE}/vidu-video-nTc04LIe-mtsb8uam-65177e70.mp4`,
  poster: `${FEATURE_VIDEO_BASE}/Frame 1686559256-fc00b1b9.webp`,
};

/** Editing 能做什么（第二段）专属：卡 3 用独立演示视频，其余卡复用 S15。 */
export const S15B_CARD3_VIDEO = {
  src: `${FEATURE_VIDEO_BASE}/vidu-video-zaQO6xEp-mtse5lin-f5f551b8.mp4`,
  poster: `${FEATURE_VIDEO_BASE}/Frame 168655925798-01737a0b.webp`,
};

/** Editing 能做什么（第二段）专属：卡 4 用独立演示视频，其余卡复用 S15。 */
export const S15B_CARD4_VIDEO = {
  src: `${FEATURE_VIDEO_BASE}/vidu-video-RmNodcDQ-mtsfljpq-fac2542f.mp4`,
  poster: `${FEATURE_VIDEO_BASE}/Frame 16865592604312-d68fd183.webp`,
};

/**
 * 热门案例：有输入图时「左输入 → 右视频」分栏；没有输入图时横版铺满内区，竖版 9:16 居中。
 * 卡片默认停在 poster，hover 整卡才带声起播 —— 多条同时循环会一直占着解码器。
 *
 * 首屏视频素材。
 */
export const HEAD_TURN_VIDEO_SRC = HERO_VIDEO_SRC;

/**
 * 首屏人物海报：正脸帧（≈1.5s）。seek 落地前先显示它，避免闪一下开头的侧脸。
 */
export const HEAD_TURN_POSTER_SRC = HERO_VIDEO_POSTER;

export type PopularCaseInput = {
  type: 'image' | 'video';
  src: string;
  poster?: string;
};

export type PopularCaseDescriptionKey =
  | 'avatarProductDemo'
  | 'backgroundReplacement'
  | 'characterReplacement'
  | 'styleRendering'
  | 'styleTransfer'
  | 'styleTransformation'
  | 'virtualTryOn';

export type PopularCaseOrientation = 'portrait' | 'landscape';

export type PopularCase = {
  id: string;
  descriptionKey: PopularCaseDescriptionKey;
  /**
   * 点击卡片跳转目标。编辑案例必须是 EDITING_MODE_ROUTES 的深链；
   * 数字人直播案例走 `/vidu-stream/avatar`。写错不会报错、只会跳到 404，
   * 所以有一条测试钉住两边一致。
   */
  href: string;
  /**
   * 无输入图时的铺法：竖版在 16:9 容器内按 9:16 居中，横版铺满内边距内的区域。
   */
  orientation: PopularCaseOrientation;
  inputs: PopularCaseInput[];
  output: {
    src: string;
    poster?: string;
  };
};

const CN_CASE_BASE = 'https://image01-aliyun.vidu.zone/vidu/media-asset';
const GLOBAL_CASE_BASE = BASE;
const AVATAR_HREF = '/vidu-stream/avatar';

/** 国内/海外都保留的旧案例：实时渲染-风格变化。 */
const STYLE_TRANSFORMATION_CASE: PopularCase = {
  id: 'style-transformation',
  descriptionKey: 'styleTransformation',
  href: buildEditingModeHref('style-rendering'),
  orientation: 'landscape',
  inputs: [{ type: 'image', src: `${BASE}/case%205-c9e4d24a.webp` }],
  output: { src: `${BASE}/case%205-9506b9c9.mp4`, poster: `${BASE}/case%205-c9e4d24a.webp` },
};

export const POPULAR_CASES_CHINA: PopularCase[] = [
  {
    id: 'cn-background-replacement',
    descriptionKey: 'backgroundReplacement',
    href: buildEditingModeHref('background-replacement'),
    orientation: 'portrait',
    inputs: [],
    output: {
      src: `${CN_CASE_BASE}/s-case-01-eb63df81.mp4`,
      poster: `${CN_CASE_BASE}/s-case-01-e203d4ee.webp`,
    },
  },
  {
    id: 'cn-avatar-product',
    descriptionKey: 'avatarProductDemo',
    href: AVATAR_HREF,
    orientation: 'landscape',
    inputs: [],
    output: {
      src: `${CN_CASE_BASE}/s-case-04-dc7aef7b.mp4`,
      poster: `${CN_CASE_BASE}/s-case-04-d95e14e2.webp`,
    },
  },
  {
    id: 'cn-virtual-try-on',
    descriptionKey: 'virtualTryOn',
    href: buildEditingModeHref('virtual-try-on'),
    orientation: 'landscape',
    inputs: [],
    output: {
      src: `${CN_CASE_BASE}/s-case-03-f6701056.mp4`,
      poster: `${CN_CASE_BASE}/s-case-03-251fc8a7.webp`,
    },
  },
  {
    id: 'cn-style-rendering',
    descriptionKey: 'styleRendering',
    href: buildEditingModeHref('style-rendering'),
    orientation: 'portrait',
    inputs: [{ type: 'image', src: `${CN_CASE_BASE}/s-case-02-input-6c25bc94.webp` }],
    output: {
      src: `${CN_CASE_BASE}/s-case-02-dbec7488.mp4`,
      poster: `${CN_CASE_BASE}/s-case-02-09d10557.webp`,
    },
  },
  {
    id: 'cn-character-replacement',
    descriptionKey: 'characterReplacement',
    href: buildEditingModeHref('character-replacement'),
    orientation: 'landscape',
    inputs: [],
    output: {
      src: `${CN_CASE_BASE}/s-case-05-7afb8cd8.mp4`,
      poster: `${CN_CASE_BASE}/s-case-05-32798745.webp`,
    },
  },
  STYLE_TRANSFORMATION_CASE,
];

export const POPULAR_CASES_GLOBAL: PopularCase[] = [
  {
    id: 'global-background-replacement',
    descriptionKey: 'backgroundReplacement',
    href: buildEditingModeHref('background-replacement'),
    orientation: 'portrait',
    inputs: [],
    output: { src: `${GLOBAL_CASE_BASE}/s-case-02-7749a745.mp4` },
  },
  {
    id: 'global-style-transfer',
    descriptionKey: 'styleTransfer',
    href: buildEditingModeHref('style-rendering'),
    orientation: 'portrait',
    inputs: [],
    output: { src: `${GLOBAL_CASE_BASE}/s-case-01-8563c3de.mp4` },
  },
  {
    id: 'global-character-replacement',
    descriptionKey: 'characterReplacement',
    href: buildEditingModeHref('character-replacement'),
    orientation: 'portrait',
    inputs: [],
    output: { src: `${GLOBAL_CASE_BASE}/s-case-03-c6bd8e06.mp4` },
  },
  {
    id: 'global-virtual-try-on-05',
    descriptionKey: 'virtualTryOn',
    href: buildEditingModeHref('virtual-try-on'),
    orientation: 'portrait',
    inputs: [],
    output: { src: `${GLOBAL_CASE_BASE}/s-case-05-9166bd30.mp4` },
  },
  {
    id: 'global-virtual-try-on-04',
    descriptionKey: 'virtualTryOn',
    href: buildEditingModeHref('virtual-try-on'),
    orientation: 'portrait',
    inputs: [],
    output: { src: `${GLOBAL_CASE_BASE}/s-case-04-31ee8cb9.mp4` },
  },
];

/** Popular Cases 的输入/输出素材配置，按国内 / 海外站点切换。 */
export const POPULAR_CASES: PopularCase[] = SITE === 'china' ? POPULAR_CASES_CHINA : POPULAR_CASES_GLOBAL;
